<template>
  <main class="panels">
    <b-container v-if="apiReady">
      <div class="section-header row">
        <h1 class="heading">Analysis</h1>

        <div class="actions">
          <div class="action">
            <b-btn variant="primary" :to="{ name: 'ExploreAnalysisCreate' }">
              <i class="fa fa-chart-area"></i> New analysis
            </b-btn>
          </div>
        </div>
      </div>

      <b-row v-for="analyse in analyses" :key="analyse._id" class="analysis">
        <b-col class="analysis-col-left">
          <div class="image">
            <b-img
              v-if="analyse.config.type === 'scatterplot'"
              src="/images/charts/scatter.svg"
              alt="Scatterplot"
              title="Scatterplot"
            ></b-img>
            <b-img
              v-if="analyse.config.type === 'heatmap'"
              src="/images/charts/pixels.svg"
              alt="Heatmap"
              title="Heatmap"
            ></b-img>
            <b-img
              v-if="analyse.config.type === 'onedheatmap'"
              src="/images/charts/grid.svg"
              alt="1D heatmap"
              title="1D heatmap"
            ></b-img>
            <b-img
              v-if="analyse.config.type === 'columnchart'"
              src="/images/charts/col-chart.svg"
              alt="Bar chart"
              title="Bar chart"
            ></b-img>
            <b-img
              v-if="analyse.config.type === 'barchart'"
              src="/images/charts/stats.svg"
              alt="Column chart"
              title="Column chart"
            ></b-img>
            <b-img
              v-if="analyse.config.type === 'linechart'"
              src="/images/charts/line.svg"
              alt="Line chart"
              title="Line chart"
            ></b-img>
            <b-img
              v-if="analyse.config.type === 'worldmap'"
              src="/images/charts/global.svg"
              alt="World map"
              title="World map"
            ></b-img>
            <b-img
              v-if="analyse.config.type === 'clustermap'"
              src="/images/charts/clustermap.svg"
              alt="Cluster map"
              title="Cluster map"
            ></b-img>
          </div>
          <div>
            <router-link
              :to="{ name: 'ExploreAnalysisView', params: { id: analyse._id } }"
            >
              <h1>{{ analyse.name }}</h1>
            </router-link>
            <p>{{ analyse.description }}</p>
            <p class="small">
              {{ analyse.config.type | ucFirst }}<br />
              {{ analyse.config.query.startyear }} &ndash;
              {{ analyse.config.query.recentyear }} &ndash;
              {{ analyse.config.query.stopyear }}
            </p>
          </div>
        </b-col>
        <b-col class="analysis-col-right">
          <div>
            <b-btn
              variant="outline-secondary"
              size="sm"
              :to="{
                name: 'ExploreAnalysisEdit',
                params: { id: analyse._id },
              }"
            >
              <i class="fa fa-edit"></i> Edit
            </b-btn>
            <b-btn
              variant="outline-secondary"
              size="sm"
              class="ml-2"
              @click="confirmDelete(analyse)"
            >
              <i class="fa fa-trash"></i> Delete
            </b-btn>
            <!--<b-btn variant="outline-secondary" size="sm" class="ml-2">
              <i class="fa fa-file-image"></i> Export SVG
            </b-btn>
            <b-btn variant="outline-secondary" size="sm" class="ml-2">
              <i class="fa fa-file-excel"></i> Export PowerPoint
            </b-btn>-->
          </div>
          <!-- <b-form-checkbox class="d-inline-block"
            >Add to report</b-form-checkbox
          > -->
        </b-col>
      </b-row>
    </b-container>
    <div
      class="container-fluid panel-bottom"
      :class="{
        opened: showDocumentsPanel,
        //leftopened: showLeftSidebar,
        //rightopened: showExploreSidebar,
        //leftrightopened: showLeftSidebar && showExploreSidebar,
        expanded: showDocumentsPanel && panelExpanded === 'expanded',
      }"
    >
      <b-row class="panel-head pt-2 pb-2">
        <b-col cols="7" class="d-flex align-items-center">
          <p class="text-overflow-ellipsis">
            {{ documentsCount }} documents
            <span class="text-muted">
              filter: {{ filterFocused ? filterFocused.name : "none" }},
              selection:
              {{
                activeElement
                  ? Array.isArray(activeElement)
                    ? activeElement[0].name
                    : activeElement.name
                  : "none"
              }}
            </span>
          </p>
        </b-col>
        <b-col class="d-flex justify-content-end align-items-center">
          <b-btn
            v-if="showDocumentsPanel"
            :variant="panelExpanded ? 'outline-secondary' : 'outline-secondary'"
            class="mr-1"
            @click="resizeDocumentsPanel"
          >
            <i class="fa fa-expand" />
          </b-btn>
          <b-btn
            v-if="showDocumentsPanel"
            variant="outline-secondary"
            class="mr-1"
            @click="clearDocFilter"
          >
            <i class="fa fa-undo" />
          </b-btn>
          <xlsx-workbook
            v-if="exportReady"
            class="btn mr-1 btn-outline-secondary p-0 d-flex"
          >
            <xlsx-sheet :collection="exportData" :sheet-name="'sheet name'" />
            <xlsx-download>
              <b-btn variant="white"><i class="fa fa-download" /></b-btn>
            </xlsx-download>
          </xlsx-workbook>
          <b-button
            v-else
            variant="outline-secondary"
            class="mr-1"
            @click="exportDocs"
          >
            <b-spinner v-if="docsLoading" small type="grow"></b-spinner>
            {{ docsLoading ? "Downloading Docs" : "Export Docs" }}
          </b-button>
          <b-form-select
            v-model="selectedCollection"
            class="custom-select custom-select-collections mr-1 mb-0"
            :options="options"
            @change="getCollectionDocs"
          ></b-form-select>
          <b-btn variant="primary" @click="toggleDocumentsPanel">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-chevron-double-down"
              viewBox="0 0 16 16"
              v-if="showDocumentsPanel"
            >
              <path
                fill-rule="evenodd"
                d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
              />
              <path
                fill-rule="evenodd"
                d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-chevron-double-up"
              viewBox="0 0 16 16"
              v-else
            >
              <path
                fill-rule="evenodd"
                d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708l6-6z"
              />
              <path
                fill-rule="evenodd"
                d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
              />
            </svg>
            <span class="ml-2">Document panel</span>
          </b-btn>
        </b-col>
      </b-row>
      <b-row class="panel-body">
        <b-col>
          <PanelBottom 
            :selection="activeElement" 
            ref="docPanel">
          </PanelBottom>
        </b-col>
      </b-row>
    </div>
    <chatbot v-if="chatbotState" />
  </main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import InitApi from "../Shared/InitApi";
import PanelBottom from "../Shared/PanelBottom";
import PanelOptions from "../Shared/PanelOptions";
import PanelTop from "../Shared/PanelTop";
import Chatbot from '../Chatbot/Chatbot.vue';

export default {
  name: "ExploreAnalysisIndex",
  extends: InitApi,
  components: {
    PanelTop,
    PanelBottom,
    PanelOptions,
    Chatbot,
  },
  data() {
    return {
      activeElement: null,
      showDocumentsPanel: false,
      showOptionsPanel: false,
      options: [{ value: null, text: "Select Collection" }],
      selectedCollection: null,
      exportReady: false,
      docsLoading: false,
      exportData: []
    }
  },
  computed: {
    ...mapState({
      analyses: (state) => state.analyse.analyses,
      apiReady: (state) => state.api.apiReady,
      filterFocused: (state) => state.filter.filterFocused,
      importedFile: (state) => state.impexp.importedFile,
      documents: (state) => state.document.documents,
      documentsExport: (state) => state.document.documentsExport,
      documentsCount: (state) => state.document.documentsCount,
      panelExpanded: (state) => state.document.documentsPanelState,
      collections: (state) => state.collection.collections,
      chatbotState: (state) => state.chatbot.chatbotState
    }),
  },
  mounted() {
    this.checkImport();
    this.setCollections();
    EventBus.$on("showDocumentsPanel", () => {
      if (!this.showDocumentsPanel) {
        this.toggleDocumentsPanel();
      }
    });
  },
  methods: {
    ...mapActions([
      "loadAnalyses",
      "deleteAnalyse",
      "saveAnalyses",
      "saveImportFile",
      "saveDocPanelState",
      "loadCollectionDocs",
      "loadDocuments",
      "exportDocuments"
    ]),
    checkImport() {
      if (!this.importedFile.status.analysis) {
        this.saveAnalyses(this.importedFile.analysis).then(() => {
          let imported = this.importedFile;
          imported.status.analysis = true;
          this.saveImportFile(imported);
        });
      }
    },
    setCollections() {
      this.options = [{ value: null, text: "Select Collection" }];
      _.each(this.collections, (coll) => {
        this.options.push({
          value: coll._id,
          text: coll.name,
        });
      });
    },
    getCollectionDocs() {
      this.loadCollectionDocs(this.selectedCollection);
    },
    confirmDelete(analyse) {
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to delete analysis “${analyse.name}”?`,
          this.$confirmOptions
        )
        .then((value) => {
          if (value) {
            this.deleteAnalyse({
              analyseId: analyse._id,
            }).then(() => {
              this.loadAnalyses();
              this.$toasted.show("Analysis deleted");
            });
          }
        });
    },
    toggleDocumentsPanel() {
      this.showDocumentsPanel = !this.showDocumentsPanel;
    },
    resizeDocumentsPanel() {
      this.panelExpanded === "default"
        ? this.saveDocPanelState("expanded")
        : this.saveDocPanelState("default");
    },
    clearDocFilter() {
      this.saveFilterQuery({ query: [] });
    },
    clearSelections() {
      this.saveFilterQuery({ query: [] });
      this.saveSubsetFilter([null]);
      this.saveActiveVisual([null]);
    },
    exportDocs() {
      this.docsLoading = !this.docsLoading;
      if (this.docsLoading) {
        /*this.loadDocuments({
          which: "global",
          page: 1,
          pageSize: this.documents.length,
          sortOn: "pubdate",
          sortAsc: false,
        }).then(() => {*/
        this.exportDocuments(_.map(this.documents, "webkey")).then(() => {
          this.formatExportDocuments();
          this.exportReady = true;
        });
        //});
      } else {
        this.exportReady = false;
      }
    },
    getMetaValues(values) {
      const v = values.map((meta) => meta[0]);
      let metaVals = [];
      v.forEach((val) => {
        metaVals.push(val.name);
      });
      return metaVals.join(" | ");
    },
    async formatExportDocuments() {
      this.exportData = [];
      this.documentsExport.forEach((d) => {
        let text = {};
        let tempObj = {};
        d.text.forEach((t) => {
          tempObj[t.name] = t.text;
          text = { ...text, ...tempObj };
        });
        Object.entries(d.meta).forEach((entry) => {
          const [key, value] = entry;
          tempObj[key.split("_")[1]] = this.getMetaValues(value);
          text = { ...text, ...tempObj };
        });
        this.exportData.push(text);
      });
    },
    resetCollection() {
      this.selectedCollection = null;
    }
  },
};
</script>
